import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-disturbute_vertical_spacing",
  "use": "icon-disturbute_vertical_spacing-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-disturbute_vertical_spacing\">\n\t<path fill=\"none\" d=\"M0,0H24V24H0Z\" />\n\t<path d=\"M16,10v4H8V10ZM6,6V7H18V6ZM6,17v1H18V17Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol